export default __webpack_public_path__ + "static/media/about--tablet.84b41551.webp";